"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperianLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class ExperianLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(experianUrl) {
        super('Experian', constants_1.LOAD_CONFIG);
        this.experianUrl = experianUrl;
    }
    getUrls() {
        return [this.experianUrl];
    }
}
exports.ExperianLoader = ExperianLoader;
//# sourceMappingURL=index.js.map